<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <b-card>
    <b-card-title>Additional Participant Details</b-card-title>

    <section v-if="!loading && additionalVisitor">
      <additional-visitor-images></additional-visitor-images>
      <additional-visitor-safeguarding-section @close="close()"></additional-visitor-safeguarding-section>
      <identity-type :person="additionalVisitor"></identity-type>
      <details-basic :person="additionalVisitor"></details-basic>
    </section>

    <b-spinner v-else variant="primary" label="Loading..."></b-spinner>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
import {mapState} from 'vuex';
import AdditionalVisitorSafeguardingSection
  from '@/components/additionalVisitors/details/sections/AdditionalVisitorSafeguardingSection.vue';
import AdditionalVisitorImages from '@/components/additionalVisitors/details/sections/AdditionalVisitorImages.vue';
import IdentityType from '@/components/sharedVisitorDetails/IdentityType.vue';
import DetailsBasic from '@/components/sharedVisitorDetails/DetailsBasic.vue';

export default {
  name: 'additional-visitor-details',
  components: {
    AdditionalVisitorSafeguardingSection,
    AdditionalVisitorImages,
    IdentityType,
    DetailsBasic,
  },
  props: {
    additional_visitor_id: {
      type: String,
      required: true,
    },
  },
  watch: {
    additional_visitor_id() {
      // Get new additional visitor info
      this.getAdditionalVisitor();
    },
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
      call: state => state.callDetails.call,
      additionalVisitor: state => state.participants.participant,
      safeguardingStatus: state => state.participants.safeguardingStatus,
    }),
  },
  data() {
    return {
      loading: true,
      loadingSafeguarding: true,
      intervalId: '', // for polling
      canRequestId: true,
    };
  },
  mounted() {
    this.getAdditionalVisitor();
    this.pollAdditionalVisitor();
  },
  beforeDestroy() {
    this.clearPolling();
  },
  methods: {
    pollAdditionalVisitor() {
      this.intervalId = setInterval(() => {
        this.getAdditionalVisitor();
      }, 300000); // 5 Mins
    },
    async getAdditionalVisitor() {
      await this.$store.dispatch('participants/getParticipant', this.additional_visitor_id);

      this.loading = false;
    },
    clearPolling() {
      clearInterval(this.intervalId);
    },
    close() {
      this.$emit('close');
    }
  },
};
</script>
